import React from 'react'
import './Container.scss'

interface IContainer extends React.HTMLAttributes<HTMLDivElement> {
    containerOuterClassName?: string
    containerInnerClassName?: string
}

const Container: React.FC<IContainer> = (props) => {
    const { children, containerInnerClassName, containerOuterClassName } = props

    const outerContainerStyles: Array<string | undefined> = ["container-outer"]
    outerContainerStyles.push(containerOuterClassName)

    const innerContainerStyles: Array<string | undefined> = ["container-inner"]
    innerContainerStyles.push(containerInnerClassName)

    return (
        <div className={outerContainerStyles.filter(Boolean).join(" ")}>
            <div className={innerContainerStyles.filter(Boolean).join(" ")}>
                {children}
            </div>
        </div>
    )
}

export default Container